import { IonHeader, IonToolbar } from "@ionic/react";
import React from "react";
import logo from "../images/logo.svg";

export default class AcrofitHeader extends React.Component{

    render (){
        return (
            <IonHeader className="no-bg fondo-colores2" mode="md" >
                <IonToolbar>
                    <div style={{textAlign:"center",display:"block",width:"100%",paddingTop:15}}>
                        <img src={logo} alt="Acrofit" width={200} />
                    </div>
                </IonToolbar>
                {
                    this.props.children
                }
            </IonHeader>
        )
    }
}